module.exports = __webpack_public_path__ + "img/dekra_logo.47cdab1a.jpg";